import { ChangeEvent, MouseEvent, forwardRef, HTMLAttributes } from 'react'

import { InputError, InputLabel, Tooltip, TooltipProps } from 'primsell-shared-layer/components'

import * as S from './input.styles'

export type InputT = 'text' | 'password' | 'number'

export interface IInputProps extends HTMLAttributes<HTMLInputElement> {
  name: string
  error?: string
  value?: string | number | null
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  onClick?: (event: MouseEvent<HTMLInputElement>) => void
  label?: string
  isRequired?: boolean
  tooltipTitle?: string
  inputTooltip?: TooltipProps
  disabled?: boolean
  className?: string
  type?: InputT
  startAdornment?: any
  endAdornment?: any
  helperText?: string
  rightHelperText?: string
  min?: number
  max?: number
}

const Input = forwardRef<HTMLInputElement | null, IInputProps>(
  (
    {
      placeholder,
      onChange,
      name,
      value,
      error,
      label,
      isRequired,
      tooltipTitle,
      disabled,
      className,
      type = 'text',
      startAdornment,
      endAdornment,
      onClick,
      helperText,
      min,
      max,
      inputTooltip,
      rightHelperText,
      ...props
    }: IInputProps,
    ref
  ) => {
    return (
      <S.InputWrapper className={className}>
        {label && (
          <InputLabel
            label={label}
            isRequired={isRequired}
            tooltipTitle={tooltipTitle}
            helperText={helperText}
            rightHelperText={rightHelperText}
          />
        )}
        <Tooltip {...inputTooltip} disabled={!inputTooltip || inputTooltip.disabled}>
          <S.InputContainer error={!!error} onClick={onClick}>
            {startAdornment && <S.StartAdornmentContainer>{startAdornment}</S.StartAdornmentContainer>}
            <S.Input
              type={type}
              name={name}
              placeholder={placeholder}
              value={value === 0 ? 0 : value || ''}
              onChange={onChange}
              disabled={disabled}
              ref={ref}
              min={min}
              max={max}
              {...props}
            />
            {endAdornment && <S.EndAdornmentContainer>{endAdornment}</S.EndAdornmentContainer>}
          </S.InputContainer>
        </Tooltip>

        {error && <InputError error={error} />}
      </S.InputWrapper>
    )
  }
)

Input.displayName = 'input'

export { Input }
